import React, { Component } from 'react'
import { Button, Select } from 'antd'
import './ecgStartReport.scss'
import moment from 'moment'
import { getHeartBeat, computeHeartPosition } from '../../common/util'
import { GetSignatureFile, getRemoteInfo } from '../../request/api'
import downloadPDF from './downloadPDF'
const { Option } = Select;
export default class ReportView extends Component {
  state = {
    //实际打印的A4纸的宽和高
    printWidth: 297,
    printHeight: 210,
    //放大的倍数
    scale: 4,
    //打印医院
    printHospital: '申请医院',
    reportDoctorSign: '',
    checkDoctorSign: '',
    ecgValue: {},
    //canvas画图的宽和高
    ecgWidth: 0,
    ecgHeight: 0,
    //屏幕像素和真实打印尺寸比例
    // proportion: (1122.52 / 297).toFixed(3),
    proportion: 3.950,
    //心率汇总
    beatsPosition: [],
    //波形增益
    sensitivity: 10,
    //显示模式
    displayModel: 1,
    //走纸速度
    paperSpeed: 25,
    //采样率
    sampling: 0,
    startValue: 0,
    startSecond: 0,
    paperSpeedMap: [
      { name: '12.5mm/s', value: 12.5 },
      { name: '25mm/s', value: 25 },
      { name: '50mm/s', value: 50 }
    ],
    sensitivityMap: [
      { name: '2.5mm/mV', value: 2.5 },
      { name: '5mm/mV', value: 5 },
      { name: '10mm/mV', value: 10 },
      { name: '20mm/mV', value: 20 },
    ],
    displayModelMap12: [
      { name: '12*1', value: 1, },
      { name: '6*2同步', value: 2, },
      { name: '6*2连续', value: 2.1, },
      { name: '6*2+1同步', value: 2.11 },
      { name: '6*2+1连续', value: 2.111 },
      { name: '4*3同步', value: 3 },
      { name: '4*3连续', value: 3.1 },
      { name: '4*3+1同步', value: 3.11 },
      { name: '4*3+1连续', value: 3.111 },
    ],
    displayModelMap18: [
      { name: '18*1', value: 1, },
      { name: '9*2同步', value: 2, },
      { name: '9*2连续', value: 2.1, },
      { name: '9*2+1同步', value: 2.11 },
      { name: '9*2+1连续', value: 2.111 },
      { name: '6*3同步', value: 3 },
      { name: '6*3连续', value: 3.1 },
      { name: '6*3+1同步', value: 3.11 },
      { name: '6*3+1连续', value: 3.111 },
    ],
    ecgLeadMap: [
      { name: "I", value: 0 },
      { name: "II", value: 1 },
      { name: "III", value: 2 },
      { name: "aVR", value: 3 },
      { name: "aVL", value: 4 },
      { name: "aVF", value: 5 },
      { name: "V1", value: 6 },
      { name: "V2", value: 7 },
      { name: "V3", value: 8 },
      { name: "V4", value: 9 },
      { name: "V5", value: 10 },
      { name: "V6", value: 11 },
      { name: "V7", value: 12 },
      { name: "V8", value: 13 },
      { name: "V9", value: 14 },
      { name: "V3R", value: 15 },
      { name: "V4R", value: 16 },
      { name: "V5R", value: 17 },
    ],
    selectEcgLead: 1,
    //是否是连续
    isContinuity: false,
  }
  componentDidMount() {
    //打印心电图配置数据信息
    this.props.validateFields((err, value) => {
      this.setState({
        ecgValue: value
      })
    })
    // this.getDoctorSign()
    this.getPrintHospital()
    if (this.props.ecgInfo.printDirection === '1') {
      this.setState({
        printWidth: 297,
        printHeight: 210
      }, () => {
        this.changeEcgSize()
      })
    } else {
      this.setState({
        printWidth: 210,
        printHeight: 297
      }, () => {
        this.changeEcgSize()
      })
    }
  }
  //获取签名方式和打印医院和信息回填
  getPrintHospital = () => {
    let settingValues = JSON.parse(localStorage.getItem('settingValues')) || {}
    let printHospital = localStorage.getItem('loginHospitalName');
    if (this.props.rowData.CONSULTATION_STATUS === '未申请') {
      this.setState({ printHospital })
    } else {
      if (settingValues.printingType === '会诊医院') {
        getRemoteInfo(this.props.rowData.EXAM_UID).then(res => {
          if (res && res.Status === 1) {
            this.setState({
              printHospital: res.Result.CONSULTATION_HOSPITAL_NAME
            })
          } else {
            this.setState({
              printHospital: localStorage.getItem('loginHospitalName')
            })
          }
        })
      } else {
        this.setState({
          printHospital: localStorage.getItem('loginHospitalName')
        })
      }
    }

    this.setState({
      startValue: Math.floor(this.props.ecgInfo.startSecond / this.props.ecgInfo.second * this.props.ecgInfo.totalLength),
      displayModel: this.props.ecgInfo.displayModel * 1,
      sensitivity: this.props.ecgInfo.sensitivity * 1,
      paperSpeed: this.props.ecgInfo.paperSpeed * 1,
      startSecond: this.props.ecgInfo.startSecond * 1,
      signatureType: settingValues.signatureType || '电子签名',
      isContinuity: this.props.ecgInfo.isContinuity,
      beatsPosition: this.props.beatsPosition,
      sampling: this.props.ecgInfo.sampling * 1
    }, () => {
      if (this.state.signatureType === '电子签名') {
        this.getDoctorSign()
      }
    })
  }
  //获取医生的电子签名
  getDoctorSign = () => {
    let EXAM_UID = this.props.rowData.EXAM_UID;
    GetSignatureFile(EXAM_UID).then(res => {
      if (res && res.Status === 1) {
        if (res.Result) {
          this.setState({
            reportDoctorSign: res.Result.REPORT_DOCTOR,
            checkDoctorSign: res.Result.CHECK_DOCTOR,
          })
        }
      }
    })
  }
  //更改打印方式(横版和竖版)
  togglePrintMode = () => {
    if (this.state.printHeight === 210) {
      this.setState({
        printWidth: 210,
        printHeight: 297
      }, () => {
        this.changeEcgSize()
      })
    } else {
      this.setState({
        printWidth: 297,
        printHeight: 210
      }, () => {
        this.changeEcgSize()
      })
    }
  }
  //更改打印方式(横版和竖版)改变尺寸
  changeEcgSize = () => {
    const { printWidth, printHeight, proportion, scale } = this.state;
    let ecgWidth = printWidth * scale * proportion - 155 * 2
    let ecgHeight = printHeight * scale * proportion - 185 * 2 - 201 * scale
    if (ecgHeight > ecgWidth) {
      ecgHeight -= 30
    }
    this.setState({
      ecgWidth,
      ecgHeight,
      proportion
    }, () => {
      this.drawGrid()
    })
  }
  //心电图方法汇总
  drawGrid = () => {
    let myCanvas = document.getElementById('ecgPrint');
    if (myCanvas.getContext) {
      let ctx = myCanvas.getContext('2d');
      let { ecgWidth, ecgHeight, proportion, scale } = this.state;
      proportion *= 1
      ctx.clearRect(0, 0, ecgWidth, ecgHeight)
      this.drawBigGrid(ctx, ecgWidth, ecgHeight, proportion, scale);
      this.drawLine(ctx, ecgWidth, ecgHeight, proportion, scale)
      this.drawSign(ctx, ecgWidth, ecgHeight, proportion, scale)
      this.drawBeats(ctx, ecgWidth, proportion, scale)
      downloadPDF(this.componentRef, this.props.rowData.NAME, this.state.printWidth === 297 ? 'row' : 'column')
      this.props.onCancel()
    }
  }
  //背景网格
  drawBigGrid = (ctx, width, height, proportion, scale) => {
    for (let x = 0, a = 0; x <= width; x += proportion * scale) {
      //每隔5个像素画一点
      if (a % 5 !== 0) {
        for (let z = 0, b = 0; z <= height; z += proportion * scale) {
          //留出来大网格横线的位置可以不用重复画
          if (b % 5 !== 0) {
            ctx.beginPath();
            ctx.lineWidth = scale / 2;
            ctx.strokeStyle = '#000';
            // ctx.strokeStyle = '#FFB4B4';
            ctx.moveTo(x, z - scale / 4);
            ctx.lineTo(x, z + scale / 4);
            // ctx.arc(x,z,0.5,0,2*Math.PI)
            ctx.stroke();
            ctx.closePath();
          }
          b++
        }
      }
      a++;
    }
    for (let x = 0.5; x <= width; x += (proportion * 5 * scale)) {
      ctx.beginPath();
      ctx.lineWidth = scale / 2;
      // ctx.strokeStyle = '#FF6464';
      ctx.strokeStyle = '#000';
      ctx.moveTo(x, 0);
      ctx.lineTo(x, height);
      ctx.stroke();
      ctx.closePath();
    }
    // //横线的位置每次都是一样的从0开始每隔25像素画一条
    for (let y = 0.5; y <= height; y += (proportion * 5 * scale)) {
      ctx.beginPath();
      ctx.lineWidth = scale / 2;
      // ctx.strokeStyle = '#FF6464';
      ctx.strokeStyle = '#000';
      ctx.moveTo(0, y);
      ctx.lineTo(width, y);
      ctx.stroke();
      ctx.closePath();
    }
    //画完网格画最下方的秒数
    this.drawSeconds(ctx, width, height, scale);
  }
  //画线
  drawLine = (ctx, width, height, proportion, scale) => {
    let { paperSpeed, sensitivity, displayModel, startValue } = this.state;
    let { ecgLead, beatArray, totalLength, sampling, transmission } = this.props.ecgInfo
    //根据数据给我的1mv的高度和选择的增益算出来我在屏幕上应该显示多高百分比
    transmission = (sensitivity * proportion) / transmission;
    let addEcg = 0;
    if (displayModel.toString().length > 3) {
      addEcg = 1
    }
    displayModel = parseInt(displayModel)
    //根据走纸速度和采样率选择我应该取的值，算出来步进
    // let speed = sampling / (paperSpeed * 5);
    let speed = 1;
    let pointXSpeed = (paperSpeed * proportion / sampling) * scale;
    //现在一列显示几导
    let nowLead = ecgLead / displayModel;
    //每一导可以占据的高度
    let vHeight = height / (nowLead + 1 + addEcg);
    //初始化一下可以画的宽度
    let endWidth = 0;
    //初始化定义一个各导联初始值,并且第一个值跟随页面变化后续变化都跟初始化的值有关
    let initStarValue = [this.state.startValue];
    //第一个循环是循环多少导，画几条数据
    for (let i = 0; i < beatArray.length; i++) {
      var arr = []
      //根据刚才的步进取值arr里面就是我需要画的每个数据
      for (let x = 0; x < totalLength; x += speed) {
        arr.push(beatArray[i][x])
        //  var arr1 = this.processingValue(beatArray[i].slice(x,x+speed+1));
        //  arr = arr.concat(arr1)
      }
      //这一导在y轴的开始位置
      let speedHeight = vHeight * (i % nowLead) + vHeight;
      //x轴的初始位置
      let pointX = 20 * scale;
      //这里没想好怎么优化两个if判断一下显示模式不一样x轴的初始位置
      if (i >= nowLead && i < (nowLead * 2)) {
        pointX = width / displayModel + 20 * scale;
      } else if (i >= (nowLead * 2)) {
        pointX = width / displayModel * 2 + 20 * scale;
      }
      //根据显示模式算出来最终可以在屏幕上画的宽度
      if (i % nowLead === 0) {
        endWidth += width / displayModel;
      }
      ctx.beginPath()
      ctx.strokeStyle = '#000';
      ctx.lineWidth = scale * 1.2;
      ctx.miterLimit = 1;
      ctx.lineJoin = 'round';
      ctx.lineCap = 'square';
      //移动到初始位置
      ctx.moveTo(pointX, speedHeight + (arr[startValue] * transmission) * scale);
      //训话，只要是数据还有或者宽度没有到达指定结尾就一直画
      while (startValue < totalLength && pointX < endWidth) {
        //因为给的值是从0开始的，但是我们y轴的位置不是从0开始的所以就需要我们的y轴的值加上我们拿到的值乘以我们刚才根据1mv的值和增益和屏幕的像素算出来的百分比
        ctx.lineTo(pointX, speedHeight + (arr[startValue] * transmission) * scale);
        pointX += pointXSpeed;
        startValue++;
      }
      //不能跟上面一块写是因为宽度需要画线开始确定，而下一列的初始值需要前一列画完才知道
      if ((i + 1) % nowLead === 0 && this.state.isContinuity) {
        initStarValue.push(startValue)
      }
      //如果不是连续的画完一导以后把初始值给初始化一下，留给下一导接着画
      if (!this.state.isContinuity) {
        startValue = initStarValue[0];
      } else {
        // 如果是连续的就需要分批才可以初始化,就需要第一列是从0开始，第二列从第一列画完的开始初始化，第三列从第二列画完开始初始化
        if (i <= nowLead - 2) {
          startValue = initStarValue[0];
        } else if (i < nowLead * 2 - 1) {
          startValue = initStarValue[1] + 26 * scale;
        } else {
          startValue = initStarValue[2] + 26 * scale;
        }
      }
      ctx.stroke();
      ctx.closePath()
    }
    if (addEcg === 1) {
      let arr = []
      for (let x = 0; x < totalLength; x += speed) {
        arr.push(beatArray[this.state.selectEcgLead][x])
        //  var arr1 = this.processingValue(beatArray[this.state.selectEcgLead].slice(x,x+speed+1));
        // arr = arr.concat(arr1)
      }
      let speedHeight = vHeight * nowLead + vHeight;
      let pointX = 20 * scale;
      ctx.beginPath()
      ctx.strokeStyle = '#000';
      ctx.lineWidth = scale * 1.2;
      ctx.miterLimit = 1;
      ctx.lineJoin = 'round';
      ctx.lineCap = 'square';
      //最后加一导要从初始值开始加
      startValue = this.state.startValue
      ctx.moveTo(pointX, speedHeight + (arr[startValue] * transmission) * scale);
      while (startValue < totalLength && pointX < width) {
        //因为给的值是从0开始的，但是我们y轴的位置不是从0开始的所以就需要我们的y轴的值加上我们拿到的值乘以我们刚才根据1mv的值和增益和屏幕的像素算出来的百分比
        ctx.lineTo(pointX, speedHeight + (arr[startValue] * transmission) * scale);
        pointX += pointXSpeed;
        startValue++;
      }
      ctx.stroke();
      ctx.closePath()
    }
  }
  //定波方标
  drawSign = (ctx, width, height, proportion, scale) => {
    let { sensitivity, displayModel } = this.state;
    let { R18, ecgLead, } = this.props.ecgInfo;
    let addEcg = 0;
    if (displayModel.toString().length > 3) {
      addEcg = 1
    }
    displayModel = parseInt(displayModel)
    //改变展示模式后六个开始的坐标
    let startPointX = -width / displayModel;
    let nowLead = ecgLead / displayModel;
    ctx.beginPath();
    ctx.strokeStyle = '#000';
    ctx.lineWidth = scale;
    //每一导的高度固定，
    let pointYHeight = height / (nowLead + 1 + addEcg);
    sensitivity *= proportion
    //循环导数，添加定波方标
    for (let i = 0; i <= ecgLead; i++) {
      //确定每个方标在y轴的位置
      let pointY = i % nowLead * pointYHeight + pointYHeight;
      if (i % nowLead === 0) {
        startPointX += width / displayModel
      }
      ctx.moveTo(startPointX, pointY)
      ctx.lineTo(startPointX + 5 * scale, pointY) //向右
      ctx.lineTo(startPointX + 5 * scale, pointY - sensitivity * scale)  //向上
      ctx.lineTo(startPointX + 10 * scale, pointY - sensitivity * scale)  //向右
      ctx.lineTo(startPointX + 10 * scale, pointY)  //向下
      ctx.lineTo(startPointX + 15 * scale, pointY)  //向右
      ctx.stroke()
      ctx.font = `normal bold ${scale * 12}px '微软雅黑'`;
      ctx.fillStyle = "#000";
      ctx.textAlign = "left";
      ctx.fillText(R18[i], startPointX + 4 * scale, pointY + 14 * scale);
    }
    ctx.closePath()
    if (addEcg === 1) {
      let pointY = nowLead * pointYHeight + pointYHeight;
      ctx.moveTo(0, pointY)
      ctx.lineTo(5 * scale, pointY) //向右
      ctx.lineTo(5 * scale, pointY - sensitivity * scale)  //向上
      ctx.lineTo(10 * scale, pointY - sensitivity * scale)  //向右
      ctx.lineTo(10 * scale, pointY)  //向下
      ctx.lineTo(15 * scale, pointY)  //向右
      ctx.stroke()
      ctx.font = `normal bold ${scale * 12}px '微软雅黑'`;
      ctx.fillStyle = "#000";
      ctx.textAlign = "left";
      ctx.fillText(R18[this.state.selectEcgLead], 4 * scale, pointY + 14 * scale);
    }
  }
  //最下方的秒数
  drawSeconds = (ctx, width, height, scale) => {
    let { paperSpeed, proportion, startValue, startSecond } = this.state;
    //*=5是按照5个像素为一格计算
    paperSpeed *= proportion * scale
    ctx.beginPath()
    ctx.strokeStyle = '#000';
    ctx.lineWidth = scale;
    //根据走纸速度和需要开始画的值，计算出现在从第几秒开始画
    // var second = parseInt(startValue / paperSpeed);
    var second = parseInt(startSecond)
    startValue = startSecond * paperSpeed
    //前面的25.5像素是定波方标的位置，不算在里面，上一步已经算出来从第几秒开始画，这一步算出来余数往前推一下算出来开始的x轴位置
    var startX = -(startValue % paperSpeed) + 21.5 * scale
    for (let i = startX; i < width; i += paperSpeed) {
      ctx.font = `${scale * 10}px '微软雅黑'`;
      ctx.fillStyle = "#000";
      ctx.textAlign = "left";
      ctx.fillText(second.toString().length < 2 ? '00:0' + second : '00:' + second, i + 2 * scale, height - 7 * scale);
      ctx.fillRect(i - 3 * scale, height - 14 * scale, 3 * scale, 15 * scale)
      second++;
    }
    //右下角的显示现在选择的走纸速度和增益
    ctx.textAlign = "right";
    ctx.font = `${scale * 12}px '微软雅黑'`;
    // ctx.fillText(this.state.paperSpeed + 'mm/s     ' + this.state.sensitivity + 'mm/mv                ' + '工频： 关    ' + '低通： 关    ' + '高通： 关    ' + '基线： 关', width - 50 * scale, height - 25 * scale);
    ctx.closePath()
  }
  //最上面的心率位置
  drawBeats = (ctx, width, proportion, scale) => {
    let { startValue, beatsPosition, sampling, paperSpeed } = this.state;
    //根据走纸速度和采样率选择我应该取的值，算出来步进
    // let speed = sampling / (paperSpeed * 5);
    let pointXSpeed = (paperSpeed * proportion / sampling) * scale;
    //需要画的标志的x轴的位置
    let pointX = [];
    beatsPosition.forEach(item => {
      pointX.push((item.Position * pointXSpeed).toFixed(2))
    })
    for (let i = 1; i <= pointX.length; i++) {
      let x = pointX[i] - startValue + 20 * scale;
      let y = pointX[i - 1] - startValue + 20 * scale;
      let heartX = (x - y) / 2 + y
      if (x <= width && x > 20 * scale) {
        ctx.font = 10 * scale + "px '微软雅黑'";
        ctx.fillStyle = "#000";
        ctx.textAlign = "center";
        ctx.fillText(getHeartBeat(beatsPosition[i].HeartBeat), x, 12 * scale);
        let position = computeHeartPosition(beatsPosition[i - 1].Position, beatsPosition[i].Position, sampling);
        ctx.fillText(position[0], heartX, 12 * scale)
        ctx.fillText(position[1], heartX, 22 * scale)
      }
    }
  }
  //改变走速
  changePaperSpeed = (e) => {
    this.setState({
      paperSpeed: e
    }, () => {
      this.drawGrid()
    })
  }
  //改变增益
  changeSensitivity = (e) => {
    this.setState({
      sensitivity: e
    }, () => {
      this.drawGrid()
    })
  }
  //打印方式
  changeDisplayModel = (e) => {
    let isContinuity = false;
    //根据定义的key值，来判断是否选择的是连续模式
    if (e.toString().length === 3 || e.toString().length === 5) {
      isContinuity = true
    }
    this.setState({
      displayModel: e,
      isContinuity
    }, () => {
      this.drawGrid()
    })
  }
  processingValue = (dataSource) => {
    let len = dataSource.length;
    let max = -32768;
    let min = 32767;
    let max_ind;
    let min_ind;
    for (let i = 0; i < len; i++) {
      if (dataSource[i] > max) {
        max = dataSource[i];
        max_ind = i;
      }
      if (dataSource[i] < min) {
        min = dataSource[i];
        min_ind = i;
      }
    }
    if (max_ind > min_ind) {
      return [min, max];
    } else {
      return [max, min];
    }
  }
  changeEcgLead = (e) => {
    this.setState({
      selectEcgLead: e
    }, () => {
      this.drawGrid()
    })
  }
  render() {
    const { ecgInfo, rowData } = this.props;
    const { ecgValue, reportDoctorSign, printHospital, checkDoctorSign, signatureType, scale } = this.state;
    let displayModelMap = this.props.ecgInfo.ecgLead === 12 ? this.state.displayModelMap12 : this.state.displayModelMap18;
    return (
      <div className="reportView">
        <div
          className="printBox"
          ref={el => (this.componentRef = el)}
          style={{
            // padding: '130px 155px',
            padding: this.state.printWidth === 297 ? '100px 108px' : '100px 122px',
            width: this.state.printWidth * scale + 'mm',
            height: this.state.printHeight * scale + 'mm',
            color: '#000',
            zoom: 1 / scale,
          }}>
          <div style={{ height: this.state.printWidth === 297 ? 200 + 'mm' : 205 + 'mm' }}>
            <div style={{ textAlign: 'center', fontSize: scale * 18 + 'px', fontWeight: 'bold' }}>{printHospital}</div>
            <div style={{ textAlign: 'center', fontSize: scale * 14 + 'px', marginBottom: this.state.printWidth === 297 ? scale * 15 + 'px' : scale * 20 + 'px' }}>{ecgInfo.ecgLead}导联同步心电图报告</div>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <p style={{ fontSize: scale * 12 + 'px' }}>记录时间：{moment(rowData.REPORT_DATETIME).format('YYYY-MM-DD HH:mm')}</p>
              <div style={{ display: 'flex', justifyContent: 'space-between', position: 'relative', fontSize: scale * 12 + 'px' }}>
                <p style={{ width: scale * 160 + 'px' }}>报告人：
                  {signatureType === '电子签名' ?
                    reportDoctorSign ? <img alt="" src={reportDoctorSign} style={{ position: 'absolute', bottom: '0' }} width={100 * scale} height={34 * scale} align="Bottom" /> : null
                    : signatureType === '打印签名' ? rowData.REPORT_DOCTOR_NAME : null}
                </p>
                <p style={{ width: scale * 160 + 'px' }}>审核人：
                  {signatureType === '电子签名' ?
                    reportDoctorSign ? <img alt="" src={checkDoctorSign} style={{ position: 'absolute', bottom: '0' }} width={100 * scale} height={34 * scale} align="Bottom" /> : null
                    : signatureType === '打印签名' ? rowData.CHECK_DOCTOR_NAME : null}
                </p>
              </div>
            </div>
            <div style={{ border: '1px solid #000' }}>
              <div
                style={{
                  height: scale * 22 + 'px',
                  lineHeight: scale * 22 + 'px',
                  display: 'flex',
                  justifyContent: 'space-between',
                  fontSize: scale * 12 + 'px',
                  padding: `0 ${scale * 10}px`,
                  borderBottom: '1px solid #000'
                }}>
                <p><span style={{ fontWeight: 'bold' }}>姓名：</span>{rowData.NAME}</p>
                <p><span style={{ fontWeight: 'bold' }}>性别：</span>{rowData.SEX_NAME}</p>
                <p><span style={{ fontWeight: 'bold' }}>年龄：</span>{rowData.EXAM_AGE}</p>
                <p><span style={{ fontWeight: 'bold' }}>科室：</span>{rowData.REQ_DEPT_NAME}</p>
                <p><span style={{ fontWeight: 'bold' }}>编号：</span>{rowData.EXAM_UID}</p>
                <p><span style={{ fontWeight: 'bold' }}>住院号：</span>{rowData.INP_NO || '无'}</p>
                <p><span style={{ fontWeight: 'bold' }}>门诊号：</span>{rowData.OUTP_NO || '无'}</p>
                <p><span style={{ fontWeight: 'bold' }}>床号：</span>{rowData.BED_NO || '无'}</p>
              </div>
              <div style={{ height: scale * 85 + 'px', display: 'flex' }}>
                <div style={{ width: scale * 300, padding: `0 ${scale * 10}px`, fontSize: scale * 12 + 'px', borderRight: '1px solid #000', lineHeight: '1.4' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <p style={{ flex: '1' }}>
                      <span style={{ fontWeight: 'bold', width: scale * 75, display: 'inline-block' }}>心率：</span>
                      <span style={{ width: scale * 55, display: 'inline-block' }}>{ecgValue.HEARTRATE}bpm</span>
                    </p>
                    <p style={{ flex: '1' }}>
                      <span style={{ fontWeight: 'bold', width: scale * 75, display: 'inline-block' }}>QT间期：</span>
                      <span style={{ width: scale * 55, display: 'inline-block' }}>{ecgValue.QTINTERAL}ms</span>
                    </p>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <p style={{ flex: '1' }}>
                      <span style={{ fontWeight: 'bold', width: scale * 75, display: 'inline-block' }}>P波：</span>
                      <span style={{ width: scale * 55, display: 'inline-block' }}>{ecgValue.PDURATION}ms</span>
                    </p>
                    <p style={{ flex: '1' }}>
                      <span style={{ fontWeight: 'bold', width: scale * 75, display: 'inline-block' }}>QTC间期：</span>
                      <span style={{ width: scale * 55, display: 'inline-block' }}>{ecgValue.QTCINTERAL}ms</span>
                    </p>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <p style={{ flex: '1' }}>
                      <span style={{ fontWeight: 'bold', width: scale * 75, display: 'inline-block' }}>QRS宽：</span>
                      <span style={{ width: scale * 55, display: 'inline-block' }}>{ecgValue.QRSDURATION}ms</span>
                    </p>
                    <p style={{ flex: '1' }}>
                      <span style={{ fontWeight: 'bold', width: scale * 75, display: 'inline-block' }}>QRS轴：</span>
                      <span style={{ width: scale * 55, display: 'inline-block' }}>{ecgValue.QRSAXIS}</span>
                    </p>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <p style={{ flex: '1' }}>
                      <span style={{ fontWeight: 'bold', width: scale * 75, display: 'inline-block' }}>PR间期：</span>
                      <span style={{ width: scale * 55, display: 'inline-block' }}>{ecgValue.PRINTERAL}ms</span>
                    </p>
                    <p style={{ flex: '1' }}>
                      <span style={{ fontWeight: 'bold', width: scale * 75, display: 'inline-block' }}>RV5+SV1：</span>
                      <span style={{ width: scale * 55, display: 'inline-block' }}>{ecgValue.RV5SV1}mV</span>
                    </p>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <p style={{ flex: '1' }}>
                      <span style={{ fontWeight: 'bold', width: scale * 75, display: 'inline-block' }}>RV5：</span>
                      <span style={{ width: scale * 55, display: 'inline-block' }}>{ecgValue.RV5}mV</span>
                    </p>
                    <p style={{ flex: '1' }}>
                      <span style={{ fontWeight: 'bold', width: scale * 75, display: 'inline-block' }}>SV1：</span>
                      <span style={{ width: scale * 55, display: 'inline-block' }}>{ecgValue.SV1}mV</span>
                    </p>
                  </div>
                </div>
                <div style={{ flex: '1', fontSize: scale * 13 + 'px', lineHeight: '1', padding: scale * 10 + 'px', overflowWrap: 'anywhere' }}>
                  <span style={{ fontWeight: 'bold' }}>检查结论：</span>{rowData.CONCLUSIONS}
                </div>
              </div>
            </div>
          </div>
          <div style={{ width: '100%', height: this.state.ecgHeight - 6, overflow: 'hidden', marginTop: scale * 3 + 'px', border: `${scale}px solid #000` }}>
            <canvas id="ecgPrint" width={this.state.ecgWidth} height={this.state.ecgHeight}></canvas>
          </div>
          <div style={{ textAlign: 'right', fontSize: 12 * scale + 'px' }}>打印时间：{moment().format('YYYY-MM-DD HH:mm')}</div>
        </div>
        <div className="settingBox">
          <div className="settingRow">走&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;速：
            <Select
              value={this.state.paperSpeed}
              onChange={this.changePaperSpeed}
              getPopupContainer={triggerNode => triggerNode.parentNode}
            >
              {this.state.paperSpeedMap.map(item => (<Option key={item.value} value={item.value}>{item.name}</Option>))}
            </Select>
          </div>
          <div className="settingRow">增&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;益：
            <Select
              value={this.state.sensitivity}
              onChange={this.changeSensitivity}
              getPopupContainer={triggerNode => triggerNode.parentNode}
            >
              {this.state.sensitivityMap.map(item => (<Option key={item.value} value={item.value}>{item.name}</Option>))}
            </Select>
          </div>
          <div className="settingRow">打印方式：
            <Select
              value={this.state.displayModel}
              onChange={this.changeDisplayModel}
              getPopupContainer={triggerNode => triggerNode.parentNode}
            >
              {displayModelMap.map(item => (<Option key={item.value} value={item.value}>{item.name}</Option>))}
            </Select>
          </div>
          <div className="settingRow">选择导联：
            <Select
              value={this.state.selectEcgLead}
              onChange={this.changeEcgLead}
              getPopupContainer={triggerNode => triggerNode.parentNode}
            >
              {this.state.ecgLeadMap.map(item => {
                if (item.value < this.props.ecgInfo.ecgLead) {
                  return <Option key={item.value} value={item.value}>{item.name}</Option>
                } else {
                  return false
                }
              })}
            </Select>
          </div>
          <Button onClick={() => { downloadPDF(this.componentRef, rowData.NAME, this.state.printWidth === 297 ? 'row' : 'column') }}>打印</Button>
          <Button onClick={this.togglePrintMode}>
            {this.state.printWidth === 297 ? '竖屏' : '宽屏'}
          </Button>
        </div>
      </div>
    )
  }
}
